<fieldset bsMigration [bs4Class]="['mb-3']" class="panel panel-{{ type }}">
  <legend bsMigration class="panel-heading">
    <div bsMigration class="btn-group btn-group-xs pull-right" role="group">
      <button type="button" class="btn btn-info" (click)="edit.emit(address)">Edit Address</button>
    </div>
    <label class="radio-inline"><input #selected class="form" type="radio" name="type" [value]="type" [checked]="type == 'primary'" (change)="value.emit(address)"> {{ title }}</label>
  </legend>
  <div bsMigration class="panel-body">
    <div *ngFor="let line of formatted">
      {{ line }}
    </div>
  </div>
</fieldset>
